import { Button, makeStyles } from "@material-ui/core"
import { colors } from "../../../utils/theme"

interface ConfirmSaveBarProps {
  onSave: () => void
}

/**
 * Sticky footer bar with a "Confirm & Save" button, fixed to the bottom of the
 * viewport. Rendered when the user has unsaved safety plan edits.
 *
 * @param onSave - Callback invoked when the button is clicked.
 */
export default function ConfirmSaveButton({ onSave }: ConfirmSaveBarProps) {
  const classes = useStyles()

  return (
    <div className={classes.confirmSaveContainer} id="confirmSave">
      <Button className={classes.confirmSaveBtn} onClick={onSave}>
        Confirm & Save
      </Button>
    </div>
  )
}

const useStyles = makeStyles(() => ({
  confirmSaveContainer: {
    display: "flex",
    padding: "24px",
    justifyContent: "center",
    background: colors.safetyPlan.grayscale.white75,
    backdropFilter: "blur(4px)",
    position: "fixed",
    bottom: "0px",
    left: 0,
    right: 0,
    width: "100%",
    zIndex: 400,
  },
  confirmSaveBtn: {
    height: "52px",
    padding: "4px 32px",
    gap: "8px",
    borderRadius: "200px",
    background: colors.primary.shadow,
    color: colors.neutral.white,
    textTransform: "none",
    width: "600px",
    transition: "0.1s",
    "&:hover": {
      background: colors.primary.midnight,
    },
  },
}))
